<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fpKjap/tc-custom/9780374714888.jpg?1742160772216" alt="This image is the cover for the book Book of Memory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of Memory
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The story that you have asked me to tell you does not begin with the pitiful ugliness of Lloyd’s death. It begins on a long-ago day in August when the sun seared my blistered face and I was nine years old and my father and mother sold me to a strange man.</i><br/><br/>Memory, the narrator of Petina Gappah’s <i>The Book of Memory</i>, is an albino woman languishing in Chikurubi Maximum Security Prison in Harare, Zimbabwe, after being sentenced for murder. As part of her appeal, her lawyer insists that she write down what happened as she remembers it. The death penalty is a mandatory sentence for murder, and Memory is, both literally and metaphorically, writing for her life. As her story unfolds, Memory reveals that she has been tried and convicted for the murder of Lloyd Hendricks, her adopted father. But who was Lloyd Hendricks? Why does Memory feel no remorse for his death? And did everything happen exactly as she remembers?<br/><br/>Moving between the townships of the poor and the suburbs of the rich, and between past and present, the 2009 Guardian First Book Award–winning writer Petina Gappah weaves a compelling tale of love, obsession, the relentlessness of fate, and the treachery of memory.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Petina Gappah
      </h2>
      
      <p class="authorDescription body article">PETINA GAPPAH’s <I>An Elegy for Easterly </I>(2009) was short-listed for the Frank O’Connor International Short Story Award and the Los Angeles Times Art Seidenbaum Award for First Fiction, and won the 2009 Guardian First Book Award. She is currently an international trade lawyer in Geneva, and she lives in Zimbabwe.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?abbc8778